import {
  TIMELINE_LEGEND_FILTER,
  type TimelineLegendFilter,
} from "constants/filingsTimeline";
import { TimelineFilingRow } from "store/apis/filingsTimeline";
import { getTimelineStatus } from "./getTimelineStatus";

export const matchesLegendFilter = (
  filing: TimelineFilingRow,
  filter: TimelineLegendFilter
): boolean => {
  if (filter === TIMELINE_LEGEND_FILTER.OVERDUE) return filing.is_overdue;

  return getTimelineStatus(filing) === filter;
};
